module.exports = __webpack_public_path__ + "img/Key2.74f5303a.gif";